import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import MyAirports from "./MyAirports/AddEditMyAirports";
import TabOne from "./TabOne/TabOne";
import { TabOnePara } from "./TabOneParagraph/TabOnePara";

export const CentralisedPrivacyPolicy: React.FC = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const activeTab = query.get("activeTab");
  const activeSubTab = query.get("subTab");

  useEffect(() => {
    if (query.get("id")) {
      return;
    }

    if (!activeTab) {
      navigate(`${window.location.pathname}?activeTab=tab-1`, { replace: true });
    } else {
      if (activeTab === "tab-1") {
        navigate(`${window.location.pathname}?activeTab=tab-1&subTab=${activeSubTab ?? "TabOneData"}`, {
          replace: true,
        });
      }

      if (activeTab === "tab-2") {
        navigate(`${window.location.pathname}?activeTab=tab-2&subTab=${activeSubTab ?? "tab-two"}`, { replace: true });
      }

      if (activeTab === "myAirportsPrivacyPolicy") {
        navigate(`${window.location.pathname}?activeTab=myAirportsPrivacyPolicy`, { replace: true });
      }
    }
  }, [activeTab, activeSubTab, navigate]);

  const items = [
    {
      label: "Privacy Policy",
      key: "tab-1",
      children: (
        <Tabs
          defaultActiveKey="TabOneData"
          onChange={(key) => navigate(`${window.location.pathname}?activeTab=tab-1&subTab=${key}`)}
          activeKey={query.get("subTab") || "TabOneData"}
          items={[
            { label: "Tab Title", key: "TabOneData", children: <TabOne /> },
            { label: "Tab Paragraph", key: "privacyPolicyTabOne", children: <TabOnePara /> },
          ]}
        />
      ),
    },

    { label: "My Airports Privacy", key: "myAirportsPrivacyPolicy", children: <MyAirports /> },
  ];

  // --- Add Button Handler ---
  const handlePrivacyPolicyAction = (activeTab: string, activeSubTab: string | null) => {
    if (activeTab === "tab-1") {
      if (activeSubTab === "privacyPolicyTabOne") {
        return (
          <Button
            icon={<Icon icon="lucide:plus" />}
            onClick={() => navigate("/centralized/privacyPolicy/privacyPolicyTabOne/add")}
          >
            Add Tab Paragraph
          </Button>
        );
      }
      return (
        <Button
          icon={<Icon icon="lucide:plus" />}
          onClick={() => navigate("/centralized/privacyPolicy/tab-1/add")}
        >
          Add Tab One
        </Button>
      );
    } else if (activeTab === "tab-2") {
      if (activeSubTab === "tab-two-paragraph") {
        return (
          <Button
            icon={<Icon icon="lucide:plus" />}
            onClick={() => navigate("/centralized/privacyPolicy/paragraph/tab-2/add")}
          >
            Add Tab Two Paragraph
          </Button>
        );
      }
      // return (
      //   <Button
      //     icon={<Icon icon="lucide:plus" />}
      //     onClick={() => navigate("/centralized/privacyPolicy/tab-2/edit")}
      //   >
      //     Add Tab Two
      //   </Button>
      // );
    } else {
      return null;
    }
  };

  return (
    <ContentWrapper
      title="Policies"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handlePrivacyPolicyAction(activeTab || "tab-1", activeSubTab)}
    >
      <Tabs
        activeKey={activeTab || "tab-1"}
        items={items}
        onChange={(key) => {
          navigate(`${window.location.pathname}?activeTab=${key}`);
        }}
      />
    </ContentWrapper>
  );
};

export default CentralisedPrivacyPolicy;
